module.exports = __webpack_public_path__ + "img/bangladesh-logo-icon.4283c658.png";